module.exports = __webpack_public_path__ + "img/purchase.d8470547.png";